import { filter, map } from 'rxjs/operators';
import { ChangeDetectorRef, Component, ElementRef, HostBinding, OnInit } from '@angular/core';
import { TranslationService } from '../../../../../config/_core/services/translation.service';
import { Navigation, NavigationStart, Router } from '@angular/router';
import { AuthService } from '../../../../../../../src/app/content/pages/auth/_core/services/auth.service';
import { PermissionNavigationService } from '../../../../../../../src/app/shared/services/permission-navigation.service';
import { MenuAsideService } from '../../../../../../../src/app/config/_core/services/menu-aside.service';
import { LangServices } from '../../../../../../../src/app/content/pages/auth/_core/services/lang.service';

interface LanguageFlag {
	lang: string;
	country: string;
	flag: string;
	active?: boolean;
}

@Component({
	selector: 'm-language-selector',
	templateUrl: './language-selector.component.html',
	styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent implements OnInit {
	// tslint:disable-next-line:max-line-length
	@HostBinding('class') classes = 'm-nav__item m-topbar__languages m-dropdown m-dropdown--small m-dropdown--arrow m-dropdown--align-right m-dropdown--header-bg-fill m-dropdown--mobile-full-width';
	@HostBinding('attr.m-dropdown-toggle') mDropdownToggle = 'click';
	language: LanguageFlag;
	languages: LanguageFlag[] = [/*
		{
			lang: 'en',
			country: 'English',
			flag: 'assets/app/media/img/flags/020-flag.svg'
		},
		{
			lang: 'es',
			country: 'Español',
			flag: 'assets/app/media/img/flags/051-peru.svg'
		},
		{
			lang: 'de',
			country: 'Deutsch',
			flag: 'assets/app/media/img/flags/017-germany.svg'
		},
		{
			lang: 'ch',
			country: '中国人',
			flag: 'assets/app/media/img/flags/015-china.svg'
		},
		{
			lang: 'jp',
			country: '日本語',
			flag: 'assets/app/media/img/flags/014-japan.svg'
		},
		{
			lang: 'fr',
			country: 'Français',
			flag: 'assets/app/media/img/flags/019-france.svg'
		},*/
	];

	constructor(
		private translationService: TranslationService,
		private router: Router,
		private cd: ChangeDetectorRef,
		private authService: AuthService,
		private lang_s:LangServices,
		private permissionNavigationService: PermissionNavigationService,
		public menuAsideService: MenuAsideService,
		private el: ElementRef
	) {}

	ngOnInit() {
		this.lang_s.getListLanguages()
		.subscribe((response: any) => {
			let dt:LanguageFlag[] = [];
			response.forEach(x=>{
				dt.push(x as LanguageFlag);
			});
			this.languages = dt;
			this.setSelectedLanguage();
			this.router.events
				.pipe(filter(event => event instanceof NavigationStart))
				.subscribe(event => {
					this.setSelectedLanguage();
				});
		});
	}

	setLanguage(lang,force=true) {
		this.languages.forEach((language: LanguageFlag) => {
			if (language.lang === lang) {
				language.active = true;
				this.language = language;
			} else {
				language.active = false;
			}
		});
		this.translationService.setLanguage(lang);

		(<DOMTokenList>this.el.nativeElement.classList).remove('m-dropdown--open');
		if(force){
			setTimeout(() => {
				this.menuAsideService.update();
				this.cd.detectChanges();
				this.cd.markForCheck();
			}, 150);

			//document.location.reload();
		}
	}

	setSelectedLanguage(): any {
		let lang = this.translationService.getSelectedLanguage();
		//console.log(lang);
		if (lang) {
			setTimeout(() => {
				this.setLanguage(lang,false);
				let item = this.languages.find(f=>f.lang==lang);
				item.active=true;
				this.language = item;
				this.cd.detectChanges();
				this.cd.markForCheck();
			},150);
		}
	}
}
